import { Collection } from "../../shared/constants"
import { isNullOrEmpty } from "../../shared/utils"
import { getAllDocsByParkId } from "./collectionBaseWorker"

export const getNewNoteSettingsByParkId = async ({ estacionamentosId }) => {
    const docs = await getAllDocsByParkId({ collection: Collection.NOTA_FISCAL_CONFIGURACAO, estacionamentoId: estacionamentosId })
    if (isNullOrEmpty(docs)) {
        return null
    }
    return docs[0]
}